import React from "react";
import {
  LastMonthGenerationHeader,
  LastMonthRevenueExportHeader,
  LastMonthRevenueOnsiteHeader,
  LastMonthSoldExportHeader,
  LastMonthSoldOnsiteHeader,
  SiteHeader,
} from "./OperationalSiteListHeaderTooltip";
import { TableHeaderCell } from "./TableHeaderCell";

const OperationalLandlordSiteListHeader: React.FC<{
  handleColumnClick: (columnName: string) => void;
  sortColumn: string;
  sortAscending: boolean;
  showHealthIndicator?: boolean;
}> = ({ handleColumnClick, sortColumn, sortAscending, showHealthIndicator }) => {
  const headerData = [
    { columnName: "name", sortValue: "name", HeaderComponent: SiteHeader },
    {
      columnName: "lastMonthCost",
      sortValue: "lastMonthCost",
      HeaderComponent: LastMonthRevenueOnsiteHeader,
    },
    {
      columnName: "lastMonthRevenueExport",
      sortValue: "lastMonthRevenueExport",
      HeaderComponent: LastMonthRevenueExportHeader,
    },
    {
      columnName: "lastMonthSoldOnsite",
      sortValue: "lastMonthSoldOnsite",
      HeaderComponent: LastMonthSoldOnsiteHeader,
    },
    {
      columnName: "lastMonthSoldExport",
      sortValue: "lastMonthSoldExport",
      HeaderComponent: LastMonthSoldExportHeader,
    },
    {
      columnName: "lastMonthGeneration",
      sortValue: "lastMonthGeneration",
      HeaderComponent: LastMonthGenerationHeader,
    },
  ];

  return (
    <tr>
      {showHealthIndicator && <th style={{ padding: "12px 8px 12px 20px", width: "48px" }}></th>}
      {headerData.map((header) => (
        <TableHeaderCell
          key={header.columnName}
          handleColumnClick={handleColumnClick}
          columnName={header.columnName}
          sortColumn={sortColumn}
          sortAscending={sortAscending}
          sortValue={header.sortValue}
          HeaderComponent={header.HeaderComponent}
        />
      ))}
      <th></th>
    </tr>
  );
};

export default OperationalLandlordSiteListHeader;
